export const AuthHandler = {
    logoutCallback: () => {},
    _loggingOut: false,

    setLogoutCallback(callback: () => void) {
        this.logoutCallback = callback;
    },

    logout() {
        const currentPath = window.location.pathname;

        if (currentPath === "/login" || this._loggingOut) {
            return;
        }

        this._loggingOut = true;

        if (this.logoutCallback) {
            console.log("Logout callback.");
            this.logoutCallback();
        } else {
            console.warn("Logout callback not register.");
        }

        // Reset after a short delay so future (intentional) logouts still work
        setTimeout(() => { this._loggingOut = false; }, 1000);
    },
};
